// assets/max-cart-items.js

const MAX_CART_ITEMS = 15;

async function getCurrentCartQuantity() {
  try {
    const response = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      console.error('[MaxCart] Konnte /cart.js nicht laden', response.status);
      return 0;
    }

    const cart = await response.json();
    const total = cart.items.reduce((sum, item) => sum + (item.quantity || 0), 0);

    console.log('[MaxCart] aktuelle Menge im Warenkorb:', total);
    return total;
  } catch (error) {
    console.error('[MaxCart] Fehler beim Laden von /cart.js', error);
    return 0;
  }
}

function showBulkOrderMessage() {
  alert(
    'Wenn du mehr als 15 Platten bestellen möchtest, melde dich bitte direkt bei uns:\n\n' +
    'angie@jakarta-records.de\n\n' +
    'Dann können wir dir einen besseren Preis für den Versand berechnen.'
  );
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('[MaxCart] Script geladen');

  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  console.log('[MaxCart] gefundene Add-to-Cart Formulare:', forms.length);

  forms.forEach((form) => {
    if (form.dataset.maxCartBound === 'true') return;
    form.dataset.maxCartBound = 'true';

    // capture: true = wir hängen uns VOR das normale Dawn-Submit
    form.addEventListener('submit', async (event) => {
      try {
        const formData = new FormData(form);
        const quantityToAdd = parseInt(formData.get('quantity') || '1', 10);

        const currentQty = await getCurrentCartQuantity();
        const newTotal = currentQty + quantityToAdd;

        console.log('[MaxCart] Submit erkannt:', {
          quantityToAdd,
          currentQty,
          newTotal
        });

        if (newTotal > MAX_CART_ITEMS) {
          // Shopify/Dawn-Logik komplett abbrechen
          event.preventDefault();
          event.stopImmediatePropagation();

          showBulkOrderMessage();
        }
        // Wenn <= MAX_CART_ITEMS → NICHT preventDefault
        // => Dawn/Scripts wickeln den Add-to-Cart normal ab
      } catch (error) {
        console.error('[MaxCart] Fehler im Submit-Handler', error);
      }
    }, { capture: true });
  });
});
